<nav class="navbar navbar-expand-lg sticky-top shdo-box">
    <div class="container pd-0">
      <button class="navbar-toggler mb-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSticky" aria-controls="navbarSticky" aria-expanded="false" aria-label="Toggle navigation">
       Menu
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSticky">
        <ul class="navbar-nav mx-auto bg_white">
            <li class="nav-item"><a class="nav-link" href="#about-us">About Us</a></li>
            <li class="nav-item"><a class="nav-link" href="#value">Our Values</a></li>
            <li class="nav-item"><a class="nav-link" href="#current_openings">Current Opportunities</a></li>
            <li class="nav-item"><a class="nav-link" href="#life-at-ftd-india">Life at FTD India</a></li>
            <li class="nav-item"><a class="nav-link" href="#footer">Contact Us</a></li>
        </ul>
      </div>
    </div>
  </nav>
